export default __webpack_public_path__ + "static/media/Sume_Descripcion.6440e699.jpg";